import useGetCoins from "@/components/pages/CartoonDetailPage/BonusQuestionSection/BonusQuestion/useGetCoins"
import { ROUTES } from "@/conf"
import { useParams, useRouter } from "next/navigation"
import { useCallback, useMemo, useState } from "react"
import { GetPlayerBonusQuestionResult } from "swagger/models"

interface useBonusQuestionProps {
  data: GetPlayerBonusQuestionResult
}

const useBonusQuestion = ({ data }: useBonusQuestionProps) => {
  const [selectedAnswers, setSelectedAnswers] = useState<Array<string>>([])
  const questionType = useMemo(() => data.answers[0].type, [data.answers])
  const router = useRouter()
  const params = useParams()

  const correctAnswers: string[] = useMemo(() => {
    return data.answers.filter((i) => i.isCorrect).map((i) => i.answerId)
  }, [data.answers])

  const { coins, handleCountCoins, answerState, setAnswerState } = useGetCoins({
    correctAnswers: correctAnswers,
    maxCoins: data.maxOfGroshak,
  })

  const handleSelectAnswer = useCallback(
    (id: string) => {
      if (selectedAnswers.includes(id)) {
        setSelectedAnswers(selectedAnswers.filter((item) => item !== id))
      } else {
        setSelectedAnswers([...selectedAnswers, id])
      }
    },
    [selectedAnswers],
  )

  const handleCheckAnswers = useCallback(() => {
    if (data?.claimed && answerState === "success") {
      router.push(`${ROUTES.cartoonDetail}/${params.slug}`)
    }
    if (selectedAnswers.length >= 1 && answerState === "") {
      handleCountCoins(selectedAnswers)
    }
    if (answerState === "failure") {
      setAnswerState("")
      setSelectedAnswers([])
    }
  }, [answerState, data?.claimed, handleCountCoins, params.slug, router, selectedAnswers, setAnswerState])

  return { coins, questionType, selectedAnswers, handleSelectAnswer, handleCheckAnswers, answerState }
}

export default useBonusQuestion
